import React, { useEffect, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import HC_more from "highcharts/highcharts-more";
import exporting from "highcharts/modules/exporting";
import { useSelector } from "react-redux";
import { images } from "../../../config";
import { useParams } from "react-router-dom";
import { ShimmerText } from "react-shimmer-effects";
import ShimmerEffectLineChart from "../../../components/ShimmerLineChart/ShimmerLinechart";

HC_more(Highcharts);
exporting(Highcharts);

export function MultiAxisLineChart({
  fisrtLineChartReportData,
  secondeLineChartReportData,
  selectFirstUnit,
  selectSecondUnit,
  selectFirst,
  selectSecond,
  Shimmer,
  selectAggReport,
  selectIntervalReport,
  unitColorsReportRedux,
}) {
  console.log(
    "unitColorsReportReduxunitColorsReportRedux",
    unitColorsReportRedux
  );

  const getInterval = (unit, aggReport, intervalReport) => {
    if (unit && typeof unit === "string") {
      const lowerUnit = unit.toLowerCase();

      if (
        lowerUnit.includes("agg") ||
        ["kwh", "kvah", "kvarh"].includes(lowerUnit)
      ) {
        // When agg and selectAggReport is 1 (daily)
        if (aggReport === "1") {
          return 1440; // 1 day in minutes
        }

        // When agg and selectAggReport is 7 (weekly)
        if (aggReport === "7") {
          return 1440 * 7; // 7 days in minutes (weekly)
        }

        // Fallback for other aggReport values
        return aggReport;
      }
    }

    // If it's not an "agg" unit, use the intervalReport
    return intervalReport;
  };

  const [interval1, setInterval1] = useState(() =>
    getInterval(selectFirstUnit, selectAggReport, selectIntervalReport)
  );

  const [interval2, setInterval2] = useState(() =>
    getInterval(selectSecondUnit, selectAggReport, selectIntervalReport)
  );

  useEffect(() => {
    setInterval1(
      getInterval(selectFirstUnit, selectAggReport, selectIntervalReport)
    );
    setInterval2(
      getInterval(selectSecondUnit, selectAggReport, selectIntervalReport)
    );
  }, [
    selectAggReport,
    selectIntervalReport,
    selectFirstUnit,
    selectSecondUnit,
  ]);

  const isFirstLineLonger =
    (fisrtLineChartReportData[0]?.data?.length || 0) >=
    (secondeLineChartReportData[0]?.data?.length || 0);

  const categories = isFirstLineLonger
    ? fisrtLineChartReportData[0]?.data.map((row) => row.MIN_KEY)
    : secondeLineChartReportData[0]?.data.map((row) => row.MIN_KEY);

  const param = useParams();

  const calculateDataPoints = (data, interval, baseInterval) => {
    if (!data || data.length === 0) return [];

    const scaledData = [];
    const scalingFactor = interval / baseInterval;

    for (let i = 0; i < data.length; i++) {
      const x = i * scalingFactor; // precise x-coordinate
      scaledData.push({
        x: x,
        y: parseFloat(data[i].tag_value),
      });
    }

    return scaledData;
  };
  const baseInterval = Math.min(interval1, interval2);

  const firstSeriesData =
    fisrtLineChartReportData.length === 0
      ? fisrtLineChartReportData[0]?.data.map((row) =>
          parseFloat(row.tag_value)
        )
      : calculateDataPoints(
          fisrtLineChartReportData[0]?.data,
          interval1,
          baseInterval
        );

  const secondSeriesData =
    secondeLineChartReportData.length === 0
      ? secondeLineChartReportData[0]?.data.map((row) =>
          parseFloat(row.tag_value)
        )
      : calculateDataPoints(
          secondeLineChartReportData[0]?.data,
          interval2,
          baseInterval
        );

  const findUnitColor1 = unitColorsReportRedux.find(
    (f) => f.tagUnit == selectFirstUnit && f.plantId == param.id
  );
  const findUnitColor2 = unitColorsReportRedux.find(
    (f) => f.tagUnit == selectSecondUnit && f.plantId == param.id
  );

  const options = {
    chart: {
      type: "spline",
      scrollablePlotArea: {
        minWidth: 700,
        scrollPositionX: categories?.length - 1, // Set scroll position to the rightmost end
      },
    },
    title: {
      text: null,
    },
    legend: {
      enabled: false, // Disable legend
    },
    xAxis: {
      categories: categories,
      scrollbar: {
        enabled: true,
      },
    },
    series: [
      {
        name: selectFirst,

        data:
          Number(interval1) === 1 || Number(interval2) === 1
            ? fisrtLineChartReportData.length &&
              fisrtLineChartReportData[0]?.data
              ? fisrtLineChartReportData[0].data.map((row) =>
                  parseFloat(row.tag_value)
                )
              : []
            : firstSeriesData,
        color: findUnitColor1 ? findUnitColor1.color : "",
        yAxis: 0,
        pointStart: 0,
        ...(fisrtLineChartReportData.length > 0 &&
        secondeLineChartReportData.length > 0 &&
        (Number(interval1) === 1 || Number(interval2) === 1)
          ? { pointInterval: Number(interval1) }
          : {}),
      },
      {
        name: selectSecond,
        data:
          Number(interval1) === 1 || Number(interval2) === 1
            ? secondeLineChartReportData.length &&
              secondeLineChartReportData[0]?.data
              ? secondeLineChartReportData[0].data.map((row) =>
                  parseFloat(row.tag_value)
                )
              : []
            : secondSeriesData,
        color: findUnitColor2 ? findUnitColor2.color : "",
        yAxis: 1,
        pointStart: 0,
        ...(fisrtLineChartReportData.length > 0 &&
        secondeLineChartReportData.length > 0 &&
        (Number(interval1) === 1 || Number(interval2) === 1)
          ? { pointInterval: Number(interval2) }
          : {}),
      },
    ],
    yAxis: [
      {
        title: {
          text: selectFirstUnit == "none" ? "" : selectFirstUnit, // First y-axis title
        },
      },
      {
        title: {
          text: selectSecondUnit == "none" ? "" : selectSecondUnit, // Second y-axis title
        },
        opposite: true, // Display the second y-axis on the opposite side
      },
    ],
    // colors: unitColorsReportRedux.length ? unitColorsReportRedux.map((e) => e.color) : [],
    exporting: {
      enabled: true, // Disable exporting options
    },
    credits: {
      enabled: false, // Disable credits
    },
    tooltip: {
      shared: true,
      formatter: function () {
        let s = `${this.x}<br/>`;
        this.points.forEach((point) => {
          s += `<br/><span style="color:${point.series.color}">\u25CF</span> ${point.series.name}: <b>${point.y}</b>`;
        });
        return s;
      },
    },
  };

  return (
    <>
      {!Shimmer ? (
        fisrtLineChartReportData.length || secondeLineChartReportData.length ? (
          <HighchartsReact highcharts={Highcharts} options={options} />
        ) : (
          <img
            src={images.noDataFoundImg}
            className="notFoundDataImg"
            alt="No DataFound Img"
            style={{ paddingTop: "100px" }}
          />
        )
      ) : (
        <ShimmerEffectLineChart />
      )}
    </>
  );
}
